import { redirect, getQueryParams } from '@/infrastructure/Utils'
import { hotelService, socialMediaService, availabilityService, roomService, bookingService, nearbyHotelsService, exchangeRatesService, labelsService } from '@/room-display/infrastructure/Factory'
import * as configuration from '@/infrastructure/Configuration'
import { buildSearchAnalytics, buildBookingAnalytics, appendData } from '@/infrastructure/Analytics'
import { translate, DateFactory } from 'rhg-vue-common'
import Categories from '@/domain/Categories'
import PaymentLabels from '@/domain/PaymentLabels'
import store from '@/store'
import { PAYMENT_OPTION } from '@/domain/FilterSelector'

export default {
  async getAvailabilityRequest ({ commit }) {
    const availabilityRequest = availabilityService.getPreviousAvailabilityRequest()
    commit('availabilityRequest', availabilityRequest)
  },

  async getLabels ({ commit }) {
    commit('busy')
    const { labels } = await labelsService.getLabels()
    global.tridionLabels = { ...configuration.tridionLabels || {}, ...labels }
    commit('labelsLoaded', true)
    commit('free')
  },

  async preBooking ({ commit, getters, state }, rate) {
    const { altFacilitatorId, facilitatorId, siteId, RK } = getQueryParams(window.location._search || window.location.search)
    const params = { }
    const availabilityRequest = { ...getters.availabilityRequest }

    if (altFacilitatorId) {
      params.altFacilitatorId = altFacilitatorId
    }
    if (facilitatorId) {
      params.facilitatorId = facilitatorId
    }
    if (siteId) {
      params.siteId = siteId
    }
    if (RK) {
      params.RK = RK
    }

    if (!getters.areMatchingRatesAvailable) {
      availabilityRequest.searchType = 'lowest'
    }

    if (getters.getTravelAgencyCustomerId) {
      availabilityRequest.travelAgencyCustomerId = getters.getTravelAgencyCustomerId
    }

    if (getters.getPromotionalCodeGroupId) {
      availabilityRequest.promotionalCodeGroupId = getters.getPromotionalCodeGroupId
    }

    const siteIdCookie = global.Cookie.read(global.cookieDictionary.siteId)
    const facilitatorIdCookie = global.Cookie.read(global.cookieDictionary.altFacilitatorId) || global.Cookie.read(global.cookieDictionary.facilitatorId)

    if (facilitatorIdCookie) {
      availabilityRequest.facilitatorId = facilitatorIdCookie
    }

    if (facilitatorIdCookie === 'ROOMKEY' && !siteIdCookie && RK) {
      availabilityRequest.merchantId = RK
    } else if (siteIdCookie) {
      availabilityRequest.merchantId = siteIdCookie
    }
    commit('loadingRate', rate.identifier)

    try {
      const rewardsNumber = state.isLogged && state.customer && state.customer.rewardsNumber
      const response = await bookingService.preBooking(availabilityRequest, rate, rewardsNumber)
      const brand = global.sessionStorage.getItem(global.sessionStorageDictionary.externalBrandPreference) || global.sessionStorage.getItem(global.sessionStorageDictionary.brandPreference)
      params.preBookingId = response.preBookingId
      params.brandOptIn = brand || 'rhg'
      params.brandPreference = brand || 'rhg'

      if (response.canApplyUpsellings) {
        redirect(configuration.upsellingPageUrl, params)
      } else {
        redirect(configuration.checkoutPageUrl, params)
      }
    } catch (error) {
      commit('error', Object.assign({}, error.response.data, { status: error.response.status }))
      commit('loadingRate', undefined)
    }
  },

  async searchRates ({ commit, getters }) {
    commit('busy')

    const showNoAvailability = (minNightsPerStay) => {
      // eslint-disable-next-line
      $('.wrapper--roomdisplay .aside--roomdisplay').hide()
      // eslint-disable-next-line
      $('.wrapper--roomdisplay .availability--roomdisplay').hide()
      // eslint-disable-next-line
      $('.wrapper--roomdisplay .holder90').hide()
      // eslint-disable-next-line
      $('.wrapper--roomdisplay .no-availability-message').show()

      const sumDays = DateFactory.daysBetween(getters.availabilityRequest.checkInDate, getters.availabilityRequest.checkOutDate)
      const minNightRate = sumDays < minNightsPerStay
      if (minNightRate) {
        // eslint-disable-next-line
        $('.no-availability-message').find( ".icon" ).removeClass('icon-calendar-no-availability').addClass('icon-calendar-arrow')
        // eslint-disable-next-line
        $('.no-availability-message').find( "span:eq( 0 )" ).removeClass('w-50').text( `${translate('srThereAreNoAvailableRoomsMinNight', minNightsPerStay, minNightsPerStay)}` );
        // eslint-disable-next-line
        $('.no-availability-message').find( "span:eq( 1 )" ).removeClass('w-50').text( `${translate('srThereAreNoAvailableRoomsMinNightSubtitle', minNightsPerStay, minNightsPerStay)}` );
      }
    }

    try {
      const { rates, customerId, groupId, minNightsPerStay } = await availabilityService.getRatesBySearchType(getters.availabilityRequest)
      commit('minNightsFromRate', minNightsPerStay)
      if (rates.length === 0) {
        showNoAvailability(minNightsPerStay)
      } else if (getters.isSpecialRate || getters.isEcert) {
        customerId && commit('travelAgencyCustomerId', customerId)
        groupId && commit('promotionalCodeGroupId', groupId)

        const searchRates = rates.filter(rate => rate.matchesSearch)
        if (searchRates.length > 0) {
          commit('rates', searchRates)
          commit('matchesRatesFound', true)
        } else {
          // eslint-disable-next-line
          $('.wrapper--roomdisplay .aside--roomdisplay').addClass('special-search-visible')
          commit('rates', rates)
          commit('matchesRatesFound', false)
        }
      } else {
        commit('rates', rates)
      }
      const bestDiscount = getters.bestDiscount
      if (bestDiscount) {
        // eslint-disable-next-line
        $('.best-discount')
          .removeClass('d-none')
          .text(translate.call({ $store: store }, 'rdOffToday', undefined, bestDiscount))
      }
      commit('free')
    } catch (error) {
      commit('error', Object.assign({}, error.response.data, { status: error.response.status }))
      showNoAvailability()
      commit('free')
    }
  },

  async getRooms ({ commit, state }) {
    commit('busy')
    try {
      const rooms = await roomService.getRooms(state.availabilityRequest.hotelCode)
      commit('rooms', rooms)
      commit('free')
    } catch (error) {
      commit('error', Object.assign({}, error.response.data, { status: error.response.status }))
    }
  },

  changePaymentOption ({ commit }, option) {
    commit('changePaymentOption', option)
  },

  toggleFocus ({ commit, state }, selector) {
    const element = state.focus === selector ? '' : selector
    commit('focus', element)
  },
  authenticate ({ commit, getters, dispatch }) {
    const handleLogin = (customer) => {
      commit('isLogged', true)
      commit('customer', customer)
    }

    global.$(window).on('auth.logged auth.postlogged', (__, customer) => {
      handleLogin(customer)
    })

    global.$(window).on('auth.postlogged', () => {
      dispatch('searchRates')
      dispatch('changeCurrentCategory', Categories.LOYALTY)
    })

    global.$(window).on('auth.nologged', () => {
      commit('isLogged', false)
    })
  },
  setCustomer({ commit }, customer) {
    commit('customer', customer)
  },
  revomeCustomer({ commit }) {
    commit('customer', null)
  },
  clearError ({ commit }) {
    commit('error', undefined)
  },

  sendAnalytics ({ state, getters }) {
    let analyticsVariables = {}
    const hasAvailability = state.rates.length > 0

    const pricing = (pricing, currencyCode) => {
      return ((pricing.price && pricing.price.amount) ? (pricing.price.amount * getters.exchangeRate(currencyCode)).toFixed(2) : '0.00') +
      '+' + (pricing.points || '0')
    }

    analyticsVariables.hotelCurrencyCode = getters.currentCurrency
    analyticsVariables = appendData(analyticsVariables, buildSearchAnalytics())
    analyticsVariables = appendData(analyticsVariables, buildBookingAnalytics())

    if (hasAvailability) {
      analyticsVariables.isNoAvailabilityResults = 'false'
      analyticsVariables.searchResultsCount = '1'

      analyticsVariables.searchRateCodesDisplayed = state.rates
        .map(rate => rate.code)
        .join('|')

      analyticsVariables.bookingRoomTypeDisplayed = state.rooms
        .map(room => (room.name || '').toLowerCase())
        .join('|')

      analyticsVariables.searchHotelRateDisplayedPerNightRateEur = state.rates
        .map(rate => (rate) ? pricing(rate.averagePricing, 'EUR') : '')
        .join('|')

      analyticsVariables.searchHotelRateDisplayedPerNightRateUsd = state.rates
        .map(rate => (rate) ? pricing(rate.averagePricing, 'USD') : '')
        .join('|')

      if (getters.getRoomsLeftForCurrentCategory) {
        analyticsVariables.bookingRoomsRemaining = getters.getRoomsLeftForCurrentCategory
      }
    } else {
      analyticsVariables.isNoAvailabilityResults = 'true'
      analyticsVariables.searchResultsCount = '0'
    }

    if (state.availabilityRequest) {
      analyticsVariables.searchAvailabilityListHotels =
              state.availabilityRequest.hotelCode + ((state.rates.length) ? '-y' : '-n')
    }

    analyticsVariables.lowestPrice = getters.lowestPriceForEachCategory
    global.trackingService.buildViewData(analyticsVariables)
    global.trackingService.triggerAnalyticsEvent()
  },

  async getNearbyHotels ({ commit, state }) {
    try {
      const { nearbyHotels } = await nearbyHotelsService.findByHotel(state.availabilityRequest.hotelCode)
      commit('nearbyHotels', nearbyHotels)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("The 'SearchResults.getNearbyHotels' action has failed: " + e)
    }
  },

  async getExchangeRates ({ commit, state }) {
    const rateWithPrices = state.rates.find(rate => !!rate.averagePricing && rate.averagePricing.price)
    if (rateWithPrices) {
      const currency = rateWithPrices.averagePricing.price.currency
      const exchangeRates = await exchangeRatesService.getExchangeRates(currency)
      commit('exchangeRates', exchangeRates)
    }
  },

  changeSelectedCurrency ({ commit, getters }, currencyCode) {
    const _getExpirationDate = () => {
      return DateFactory.addDays(DateFactory.today(), 30)
    }
    commit('selectedCurrency', currencyCode)
    if (currencyCode.key === 'hotelCurrency') {
      global.Cookie.remove('preferredCurrency')
    } else {
      global.Cookie.create('preferredCurrency', currencyCode.key, { expires: _getExpirationDate() })
    }
    const lowestPricePerCategory = getters.lowestPriceForEachCategory

    global.trackingService.track(global.trackingService.eventBuilder(global.trackingEvents.SELECT_NEW_CURRENCY, { lowestPrice: lowestPricePerCategory }))
  },

  loadInitialCurrency ({ commit }) {
    const storedCurrency = global.Cookie.read('preferredCurrency')
    commit('selectedCurrency', { key: storedCurrency || 'hotelCurrency' })
  },

  async selectHotelByCode ({ commit }, code) {
    commit('selectedHotel', code)
  },

  clearSelectedHotel ({ commit }) {
    commit('selectedHotel')
  },

  setAvailableSocialLinks ({ commit }) {
    const socialMedia = socialMediaService.socialMedia()
    commit('socialMedia', [...socialMedia])
  },

  trackSocialMediaShare () {
    global.trackingService.track(global.trackingEvents.SOCIAL_MEDIA_SHARE)
  },

  async getHotel ({ commit }, hotelCode) {
    const { overviewPath, checkInTime, checkOutTime, memberOnlyRate, tierDiscount, tmsCode, name } = await hotelService.getHotel(hotelCode)
    commit('hotelName', name)
    commit('overviewPath', overviewPath)
    commit('tmsCode', tmsCode)
    commit('checkInTime', checkInTime)
    commit('checkOutTime', checkOutTime)
    commit('memberOnlyRate', memberOnlyRate)
    commit('isTier', tierDiscount)
  },

  trackTabChange ({ getters }, category) {
    const eventData = {
      bookingRoomsRemaining: getters.getRoomsLeftForCurrentCategory
    }

    global.trackingService.track(global.trackingService.eventBuilder(global.trackingEvents.CLICK_RATE_TYPE[category], eventData))
  },
  changeCurrentCategory ({ commit }, category) {
    commit('currentCategory', category)
  },
  setInitialPaymentType ({ commit, getters, state }) {
    const { paymentType, paymentOption } = getQueryParams(window.location._search || window.location.search)
    const payments = getters.paymentOptionsByCategory

    const adaptedParam = paymentType
      ? 'rd' + paymentType.replace(paymentType.charAt(0), paymentType.charAt(0).toUpperCase())
      : (paymentOption || null)

    const paramSuitOptions = adaptedParam ? payments.find(option => option.key === adaptedParam) : null
    const isCashAndPoints = paramSuitOptions && (paramSuitOptions.key === PaymentLabels.CASH_AND_POINTS)
    const isOnlyCash = paramSuitOptions && (paramSuitOptions.key === PaymentLabels.ONLY_CASH)
    const isOnlyLoyalty = !getters.rateCategories.includes(Categories.STANDARD) && !getters.rateCategories.includes(Categories.PACKAGE)
    const isCategoryLoyalty = state.currentCategory === Categories.LOYALTY

    if (!isCategoryLoyalty && isCashAndPoints) {
      commit('currentCategory', Categories.LOYALTY)
      commit('changePaymentOption', paramSuitOptions)
    } else if (isCategoryLoyalty && isOnlyLoyalty) {
      commit('changePaymentOption', payments[2])
    } else if (isOnlyCash && isCategoryLoyalty) {
      commit('changePaymentOption', payments[0])
    } else if ((paymentType || paymentOption) && paramSuitOptions) {
      commit('changePaymentOption', paramSuitOptions)
    } else {
      commit('changePaymentOption', payments[0])
    }
  },
  setInitialCategory ({ commit, getters, state }) {
    const { activeTab, searchType, paymentType } = getQueryParams(window.location._search || window.location.search)
    if (`RD${paymentType ? paymentType.toUpperCase() : ''}` === PAYMENT_OPTION.ONLY_POINTS_AND_CASH_POINTS.toUpperCase()) {
      commit('currentCategory', Categories.LOYALTY)
    } else {
      const showLoyaltyRates = (searchType === 'lowest' && (state.memberOnlyRate || getters.hasBookAndJoin || state.displayLoyaltyRates))
      const isLoyalty = state.isLogged || showLoyaltyRates
      const category = isLoyalty && getters.rateCategories.find(rateCategory => rateCategory === Categories.LOYALTY) ? Categories.LOYALTY : activeTab || configuration.defaultNonLoggedTab
      const categoryExists = getters.rateCategories.find(rateCategory => rateCategory === category)
      commit('currentCategory', categoryExists ? category : getters.rateCategories[0])
    }
  }
}
